import { gql } from '@apollo/client';

export const SAVE_ITEM_GENERAL_DATA = gql`
  mutation saveItemGeneralData($input: ItemGeneralDataInput!) {
    saveItemGeneralData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_PROPERTY_GENERAL_DATA = gql`
  mutation savePropertyGeneralData($input: PropertyGeneralDataInput!) {
    savePropertyGeneralData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_PROPERTY_VALUES = gql`
  mutation savePropertyValues($input: [PropertyValueInput!]) {
    savePropertyValues(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_PROPERTY_VALUE = gql`
  mutation savePropertyValue($input: PropertyValueInput!) {
    savePropertyValue(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_ITEM = gql`
  mutation deleteItem($input: DeleteItemInput!) {
    deleteItem(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_ITEM_PROPERTY = gql`
  mutation deleteItemProperty($input: DeleteItemPropertyInput!) {
    deleteItemProperty(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_PROPERTY_VALUE = gql`
  mutation deletePropertyValue($input: DeletePropertyValueInput!) {
    deletePropertyValue(input: $input) {
      commandId
      correlationId
    }
  }
`;
